<vue-panel
    [title]="(editMode ? 'panelLabel.securityQuestions' : 'label.securityQuestions') | translate: 'PortalBase' | async"
    [action1Label]="'label.edit' | translate: 'PortalBase' | async"
    (action1ButtonClicked)="editSecurityQuestions()">
    <vue-security-questions
        #securityQuestionsComponent
        [formError]="formError"
        [mode]="viewMode"
        [selectedQuestions] = "selectedQuestions"
        [questionGroups]="securityQuestions"
        inputWidthClass="wider"
        (answered)="updateFormInput($event)"></vue-security-questions>
    <form class="app-form" #myForm="ngForm">
      <vue-control-group *ngIf = "editMode"
        [label]="'label.account.confirmPassword' | translate: 'PortalBase' | async"
        widthClass="wider"
        [control]="requiredInput"
        [formError]="formError"
      >
        <input
          autocomplete="off"
          autofocus
          class="form-control"
          name="requiredInput"
          type="password"
          required
          #inputElement
          id="requiredInput"
          #requiredInput="ngModel"
          [(ngModel)]="currentPassword"
        />
      </vue-control-group>
    </form>
    <vue-form-buttons
          *ngIf = "editMode"
          [secondaryLabel]="'label.cancel' | translate: 'PortalBase' | async"
          (secondaryButtonClicked)="changeToViewMode()"
          [primaryLabel]="'label.save' | translate: 'PortalBase' | async"
          (primaryButtonClicked)="save()">
    </vue-form-buttons>
</vue-panel>
